module.exports = __webpack_public_path__ + "static/media/taggis-logo-icon.93dc9a12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/taggis-logo-icon.svg
// module id = 272
// module chunks = 3